"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = exports.WrapperTitle = exports.Wrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentCardGroupStyles__Wrapper",
  componentId: "sc-1fv4qp1-0"
})(["background:#424b5f;border-radius:0.6rem;padding:0.2rem;width:95%;margin:0.5rem auto;"]);

exports.Wrapper = Wrapper;

var WrapperTitle = _styledComponents["default"].div.withConfig({
  displayName: "ShipmentCardGroupStyles__WrapperTitle",
  componentId: "sc-1fv4qp1-1"
})(["display:flex;flex-direction:row;align-items:flex-end;width:95%;margin:auto;padding-top:0.2rem;"]);

exports.WrapperTitle = WrapperTitle;

var Title = _styledComponents["default"].h2.withConfig({
  displayName: "ShipmentCardGroupStyles__Title",
  componentId: "sc-1fv4qp1-2"
})(["font-size:1rem;color:white;"]);

exports.Title = Title;